<nav mat-tab-nav-bar [mat-stretch-tabs]="false" [tabPanel]="tabPanel">
    <a mat-tab-link *ngFor="let link of links" (click)="onClickTabItem(link)" [active]="activeLink == link">
        {{link.label|translate:link.labelParams}} </a>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>